module.exports = __webpack_public_path__ + "img/enarmonisi-oikogeniaki-logo.a83acf5f.svg";